import { useQuery } from '@tanstack/react-query'
import { apiFetch } from './api'

export interface AuthedAdmin {
	adminId: string
	email: string
	isActive: boolean
}

// The authoritative check. Better Auth will happily issue a session to a
// deactivated admin (it does not know about isActive), so a valid cookie is not
// the same as having access — only the backend's requireAdmin can say. This
// asks it, and a 403 here is what surfaces "your account has been deactivated".
export function useAdmin() {
	return useQuery({
		queryKey: ['me'],
		queryFn: () => apiFetch<{ admin: AuthedAdmin }>('/api/admin/me').then((r) => r.admin),
		retry: false,
		staleTime: 60_000,
	})
}
